import React, { FC } from "react";

interface ChallengeType {
    challengeTitle: string;
    challengeList: Array<string>;
}
const Challenge: FC<ChallengeType> = ({ challengeTitle, challengeList }) => {
    return (
        <section className="">
            <h2 className="casestudy-header font-normal">
                <span className="text-dark-brown font-bold">Challenge:</span> {challengeTitle}
            </h2>
            <ul>
                {challengeList.map((listitem, index) => (
                    <li key={`${index}-${listitem}`} className="content">
                        {listitem}
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Challenge;
